import { ReactNode } from "react";
import styles from "../../styles/welcome.module.css";

/**
 * The error block from the IwC login card: tinted panel, hairline border, and an
 * icon set beside the text rather than above it.
 *
 * The icon is inline SVG rather than an icon-library import. The landing screens
 * pull in nothing else from MUI, and one 16px triangle is not worth the bundle.
 */
const Alert = ({ children }: { children: ReactNode }) => (
  <div className={styles.alert} role="alert">
    <svg
      className={styles.alertIcon}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
    <p className={styles.clientIdError}>{children}</p>
  </div>
);

export default Alert;
